import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { customerApi } from '@/lib/api';
import { toast } from 'sonner';

// Registers this device for push (native app only — no-op on the web/PWA build) and forwards the
// FCM/APNs token to our backend so staff-triggered events (low balance, top-up, bonus, activation)
// can reach the customer even when the app isn't open.
export function usePushNotifications(enabled) {
  useEffect(() => {
    if (!enabled || !Capacitor.isNativePlatform()) return;

    let registrationListener;
    let errorListener;
    let receivedListener;
    let actionListener;

    (async () => {
      const permission = await PushNotifications.checkPermissions();
      let granted = permission.receive === 'granted';
      if (!granted) {
        const requested = await PushNotifications.requestPermissions();
        granted = requested.receive === 'granted';
      }
      if (!granted) return;

      registrationListener = await PushNotifications.addListener('registration', async (token) => {
        try {
          await customerApi.post('/notifications/register-device', {
            token: token.value,
            platform: Capacitor.getPlatform() === 'ios' ? 'IOS' : 'ANDROID',
          });
          localStorage.setItem('tiffin_push_token', token.value);
        } catch {
          // Non-fatal — device just won't receive push until next successful registration.
        }
      });

      errorListener = await PushNotifications.addListener('registrationError', () => {});

      receivedListener = await PushNotifications.addListener('pushNotificationReceived', (notification) => {
        toast.info(notification.title || 'THE TIFFIN', { description: notification.body });
      });

      actionListener = await PushNotifications.addListener('pushNotificationActionPerformed', () => {
        window.location.href = '/account';
      });

      await PushNotifications.register();
    })();

    return () => {
      registrationListener?.remove();
      errorListener?.remove();
      receivedListener?.remove();
      actionListener?.remove();
    };
  }, [enabled]);
}
